import React from 'react';

const Datenschutz = () => {
  return (
    <div className="drawer-page">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4">Datenschutzerklärung</h1>
      
      <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>1. Verantwortliche Stelle</h3>
          <p className="text-sm text-gray-600">
            Verantwortlich für die Datenbearbeitung auf dieser Plattform ist:
            Klimagrosseltern Winterthur,
            Schönholzweg 45, 8409 Winterthur, <a href="mailto:hello@grosskinder-aktiv.ch" className="text-blue-600 hover:underline">hello@grosskinder-aktiv.ch</a>
          </p>
        </div>
      </div>
      <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>2. Welche Daten erfassen wir?</h3>    
          <p className="text-sm text-gray-600">        
            <li>Registrierungsdaten: Benutzername, E-Mail-Adresse, Wohnort (für ÖV-Berechnung)</li>
            <li>Von Ihnen erstellte Aktivitäten</li>
            <li>Technische Nutzungsdaten: Aufgerufene Seiten, Zugriffszeitpunkt, IP-Adresse (anonymisiert)</li>     
          </p>
        </div>
      </div>
      <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>3. Zweck der Datenbearbeitung</h3>
          <p className="text-sm text-gray-600">
            Ihre Daten werden ausschließlich zur
            Bereitstellung und Verbesserung der Dienste dieser Plattform verwendet.   
            <li>Bereitstellung und Betrieb der Plattform</li>
            <li>Benutzerauthentifizierung und Kontoverwaltung</li>
            <li>Berechnung von ÖV-Verbindungen ab Ihrem Wohnort</li>           
          </p>
        </div>
      </div>
      <div>
      <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>4. Weitergabe an Drittdienste</h3>
          <p className="text-sm text-gray-600">
          <strong>SBB OpenData API (transport.opendata.ch): </strong>Ihr Wohnort/Startort wird zur Berechnung von ÖV-Verbindungen übermittelt.
          Die Verarbeitung erfolgt gemäss den Datenschutzbestimmungen der SBB.    
          </p>
          <p className="text-sm text-gray-600">
          <strong>Google Places API (transport.opendata.ch): </strong>Zur Abfrage von Öffnungszeiten von Aktivitäten werden Standortdaten übermittelt.
          Die Verarbeitung erfolgt gemäss den Datenschutzbestimmungen von Google.    
          </p>
          <p className="text-sm text-gray-600">  
          Eine darüber hinausgehende Weitergabe an Dritte findet nicht statt.
          </p>
        </div>
      </div>
      <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>5. Aufbewahrungsdauer</h3>  
          <p className="text-sm text-gray-600">
          Ihre Daten werden so lange gespeichert, wie es für die Bereitstellung der Dienste
          erforderlich ist oder bis Sie die Löschung Ihrer Daten verlangen. Registrierungsdaten
          und von Ihnen erstellte Aktivitäten werden auf unbestimmte Zeit gespeichert,
          bis Sie eine Löschung beantragen. Technische Nutzungsdaten werden anonymisiert und nach 12 Monaten gelöscht.
          </p>
        </div>
      </div>
      <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>6. Cookies</h3>  
          <p className="text-sm text-gray-600">
          Diese Website verwendet technisch notwendige Cookies für die Authentifizierung
          sowie optionale Cookies zur Verbesserung der Nutzererfahrung. Sie können Ihren Browser so
          konfigurieren, dass Cookies abgelehnt werden, was jedoch die Funktionalität einschränken kann.
          </p>
          </div>
          </div>
          <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>7. Ihre Rechte</h3>  
          <p className="text-sm text-gray-600">
          <li>Auskunft über Ihre gespeicherten Daten zu verlangen</li>
          <li>Unrichtige Daten berichtigen zu lassen</li>
          <li>Ihre Daten löschen zu lassen</li>
          <li>Der Datenbearbeitung zu widersprechen</li>
          <li>Ihre Daten in einem gängigen Format zu erhalten (Datenübertragbarkeit)</li>
          </p>
          </div>
          </div>
          <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>8. Beschwerderecht</h3>  
          <p className="text-sm text-gray-600">
          Wenn Sie der Ansicht sind, dass die Bearbeitung Ihrer Daten gegen das
          Datenschutzrecht verstösst, können Sie beim Eidgenössischen Datenschutz- und
          Öffentlichkeitsbeauftragten (EDÖB) Beschwerde einreichen: <a href="mailto:datenschutz@edoeb.admin.ch" className="text-blue-600 hover:underline">datenschutz@edoeb.admin.ch</a>
          </p>
        </div>
      </div>
      <div className="card p-6 mb-6">
        <div className="space-y-6">
          <h3>9. Kontakt</h3>  
          <p className="text-sm text-gray-600">
          Bei Fragen zum Datenschutz wenden Sie sich an:{' '} 
          <a href="mailto:hello@grosskinder-aktiv.ch" className="text-blue-600 hover:underline">hello@grosskinder-aktiv.ch</a>
          </p>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
